import { render, staticRenderFns } from "./VLink.vue?vue&type=template&id=dd4cc4e0&"
import script from "./VLink.vue?vue&type=script&lang=js&"
export * from "./VLink.vue?vue&type=script&lang=js&"
import style0 from "./VLink.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd4cc4e0')) {
      api.createRecord('dd4cc4e0', component.options)
    } else {
      api.reload('dd4cc4e0', component.options)
    }
    module.hot.accept("./VLink.vue?vue&type=template&id=dd4cc4e0&", function () {
      api.rerender('dd4cc4e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VLink.vue"
export default component.exports